import { render, staticRenderFns } from "./VisitorLeadScanTab.vue?vue&type=template&id=b6df7b2c&scoped=true"
import script from "./VisitorLeadScanTab.vue?vue&type=script&lang=js"
export * from "./VisitorLeadScanTab.vue?vue&type=script&lang=js"
import style0 from "./VisitorLeadScanTab.vue?vue&type=style&index=0&id=b6df7b2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6df7b2c",
  null
  
)

export default component.exports